"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryRecorderProvider = exports.defaultEventRecordingOptions = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
/**
 * Make everything available from the top level.
 */
__exportStar(require("./exporters"), exports);
__exportStar(require("./processors"), exports);
__exportStar(require("./api"), exports);
exports.defaultEventRecordingOptions = {
    bufferTimeMs: 0,
    bufferMaxSize: 10,
    errorHandler: (error) => {
        console.error("@sourcegraph/telemetry:", error);
    },
};
/**
 * EventRecorderProvider is a factory for EventRecorder instances with a default
 * exporter and set of processors.
 *
 * getRecorder can be used to retrive recorder instances backed by the same
 * exporter. Additional processors can be stacked on top as well.
 */
class TelemetryRecorderProvider {
    constructor(source, exporter, processors = [], options = exports.defaultEventRecordingOptions) {
        this.source = source;
        this.processors = processors;
        this.submitter =
            options.bufferTimeMs == 0 || options.bufferMaxSize == 0
                ? new SimpleSubmitter(exporter, options)
                : new BatchSubmitter(exporter, options);
    }
    /**
     * Create a EventRecorder with the configured default processors and exporter.
     *
     * Additional processors can be passed to extend the defaults.
     */
    getRecorder(additionalProcessors) {
        return new EventRecorder(this.source, this.submitter, additionalProcessors
            ? this.processors.concat(additionalProcessors)
            : this.processors);
    }
    /**
     * Clears any ongoing work and releases buffer resources. It must be
     * called when the provider is no longer needed.
     *
     * Implements rxjs Unsubscribable.
     */
    unsubscribe() {
        this.submitter.unsubscribe();
    }
}
exports.TelemetryRecorderProvider = TelemetryRecorderProvider;
class SimpleSubmitter {
    constructor(exporter, options) {
        this.exporter = exporter;
        this.options = options;
    }
    submit(event) {
        this.exporter
            .exportEvents([event])
            .catch((err) => this.options.errorHandler(err))
            .then(() => { });
    }
    unsubscribe() { }
}
/**
 * BatchSubmitter buffer events into batches for export.
 */
class BatchSubmitter {
    constructor(exporter, options) {
        this.exporter = exporter;
        this.options = options;
        this.events = new rxjs_1.Subject();
        this.completeEvents = new rxjs_1.Subject();
        this.events
            .pipe((0, operators_1.takeUntil)(this.completeEvents), (0, operators_1.bufferTime)(options.bufferTimeMs, null, options.bufferMaxSize), (0, operators_1.concatMap)((events) => events.length > 0 ? exporter.exportEvents(events) : rxjs_1.EMPTY), (0, operators_1.catchError)((error) => {
            options.errorHandler(error);
            return [];
        }))
            .subscribe();
    }
    submit(event) {
        if (!this.events.closed) {
            this.events.next(event);
        }
        else {
            // Best-effort attempt to export after events are closed. We log an error
            // after succeeding to indicate something probably isn't implemented right.
            this.exporter
                .exportEvents([event])
                .catch((err) => this.options.errorHandler(err))
                .then(() => this.options.errorHandler("submitted event after complete"));
        }
    }
    unsubscribe() {
        // Flush any buffered events
        this.completeEvents.next();
        // Finish work and unsubscribe
        this.events.complete();
        this.events.unsubscribe();
    }
}
/**
 * EventRecorder is the standard implementation of TelemetryEventRecorder. It
 * applies processors and then submits events to the underlying EventSubmitter
 * for export.
 */
class EventRecorder {
    constructor(source, submitter, processors = []) {
        this.source = source;
        this.submitter = submitter;
        this.processors = processors;
    }
    /**
     * Record an event.
     */
    recordEvent(feature, action, parameters) {
        const apiEvent = {
            feature,
            action,
            source: this.source,
            parameters: parameters
                ? {
                    version: parameters.version || 0,
                    interactionID: parameters.interactionID,
                    metadata: parameters.metadata
                        ? Object.entries(parameters.metadata).map(([key, value]) => ({
                            key,
                            value: value || 0,
                        }))
                        : undefined,
                    privateMetadata: parameters.privateMetadata,
                    billingMetadata: parameters.billingMetadata,
                }
                : {
                    version: 0,
                },
        };
        for (const processor of this.processors) {
            processor.processEvent(apiEvent);
        }
        this.submitter.submit(apiEvent);
    }
}
//# sourceMappingURL=index.js.map